import "slick-carousel";
import { Loader } from "@googlemaps/js-api-loader";
import { GridAlgorithm, MarkerClusterer } from "@googlemaps/markerclusterer";
import GoogleMap from "../utils/map";

const templateHome = {
  prev_arrow:
    '<button class="slick-prev" aria-label="prev"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="34.063" viewBox="0 0 18 34.063"><defs><clipPath><rect width="18" height="34.063"/></clipPath></defs><g class="b" transform="translate(0 0)"><path class="c" d="M2.333,17.031,17.716,1.647A.964.964,0,1,0,16.353.284L.284,16.353a.961.961,0,0,0,0,1.363L16.353,33.778a.968.968,0,0,0,.678.285.941.941,0,0,0,.678-.285.961.961,0,0,0,0-1.363Z" transform="translate(0 0)"/></g></svg></button>',

  next_arrow:
    '<button class="slick-next" aria-label="next"><svg class="icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="34.076" viewBox="0 0 18 34.076"><defs><clipPath><rect width="18" height="34.075"/></clipPath></defs><g class="b"><path class="c" d="M17.722,16.359,1.648.284A.965.965,0,0,0,.284,1.648L15.673,17.037.284,32.426a.961.961,0,0,0,0,1.364.97.97,0,0,0,.678.286.94.94,0,0,0,.678-.286L17.715,17.715A.959.959,0,0,0,17.722,16.359Z"/></g></svg></button>',

  init: function () {
    this.init_slider();
    this.map.init();
  },

  map: {
    lat: 61.217874,
    lng: 19.700035,
    zoom: 4,
    el: $(".google__map"),
    data: window.map,

    init: function () {
      const loader = new Loader({
        apiKey: gmap_api_key,
        version: "weekly",
      });

      loader.load().then((google) => {
        templateHome.map.start();
      });
    },

    start() {
      google.maps.Map.prototype.setCenterWithOffset = function (
        latlng,
        offsetX,
        offsetY
      ) {
        let map = this;
        let ov = new google.maps.OverlayView();
        ov.onAdd = function () {
          let proj = this.getProjection();
          let aPoint = proj.fromLatLngToContainerPixel(latlng);
          aPoint.x = aPoint.x + offsetX;
          aPoint.y = aPoint.y + offsetY;
          map.setCenter(proj.fromContainerPixelToLatLng(aPoint));
        };
        ov.draw = function () {};
        ov.setMap(this);
      };

      MarkerClusterer.prototype.calculator_ = function (markers, numStyles) {
        let index = 0;
        let count = markers.length;
        let dv = count;
        while (dv !== 0) {
          dv = parseInt(dv / 10, 10);
          index++;
        }

        index = Math.min(index, numStyles);

        let houseSum = 0;
        markers.forEach(function (marker) {
          houseSum += parseInt(marker.label.text);
        });

        return {
          text: houseSum,
          index: index,
        };
      };

      templateHome.map.render_map();
    },

    render_map: function () {
      let self = this;

      let map_options = {
        zoom: self.zoom,
        center: {
          lat: self.lat,
          lng: self.lng,
        },
        scrollwheel: false,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: false,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_TOP,
        },
        styles: [
          {
            featureType: "all",
            elementType: "labels.text.fill",
            stylers: [
              {
                saturation: 36,
              },
              {
                color: "#ffffff",
              },
              {
                lightness: "-56",
              },
            ],
          },
          {
            featureType: "all",
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "off",
              },
              {
                color: "#000000",
              },
              {
                lightness: 16,
              },
            ],
          },
          {
            featureType: "all",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#000000",
              },
              {
                lightness: 20,
              },
            ],
          },
          {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#000000",
              },
              {
                lightness: 17,
              },
              {
                weight: 1.2,
              },
            ],
          },
          {
            featureType: "administrative.country",
            elementType: "geometry",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#2c283a",
              },
              {
                weight: "0.28",
              },
            ],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#ffffff",
              },
              {
                lightness: "-35",
              },
            ],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.text.stroke",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "administrative.locality",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#ffffff",
              },
              {
                lightness: "-54",
              },
              {
                weight: "0.68",
              },
            ],
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                visibility: "on",
              },
              {
                color: "#343042",
              },
            ],
          },
          {
            featureType: "poi",
            elementType: "all",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#2c283a",
              },
            ],
          },
          {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "all",
            stylers: [
              {
                visibility: "on",
              },
            ],
          },
          {
            featureType: "transit",
            elementType: "geometry.fill",
            stylers: [
              {
                color: "#2c283a",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#2c283a",
              },
            ],
          },
          {
            featureType: "water",
            elementType: "labels.text",
            stylers: [
              {
                visibility: "off",
              },
            ],
          },
        ],
      };

      let map = new google.maps.Map(self.el[0], map_options);
      let markers = [];
      let activeBubble = -1;

      let infoBubble = new google.maps.InfoWindow({
        content: `<div class="marker__pop"><a href="${self.data.more_url}">${self.data.more_title}</a></div>`,
        arrowSize: 70,
        arrowPosition: 50,
        arrowStyle: 0,
        shadowStyle: 0,
        padding: 0,
        borderRadius: 0,
        borderWidth: 0,
        backgroundClassName: "google__popup",
        backgroundColor: "transparent",
        maxWidth: 300,
        minWidth: 300,
        closeSrc: self.el.data("close"),
      });

      self.data.locations.forEach(function (location) {
        if (location.location) {
          let latlng = location.location.split(",");

          latlng = new google.maps.LatLng(latlng[0], latlng[1]);

          let image = {
            url: "/themes/base/app/img/pin.svg",
            size: new google.maps.Size(36, 30),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(18, 15),
          };

          let marker = new google.maps.Marker({
            position: latlng,
            draggable: false,
            map: map,
            label: {
              text: location.count,
              color: "#fff",
              fontFamily: "Klavika",
              fontSize: "13px",
              fontWeight: "bold",
            },
            icon: image,
          });
          markers.push(marker);
          marker.addListener("click", function () {
            if (activeBubble != -1) activeBubble.close();
            activeBubble = infoBubble;
            infoBubble.open(map, marker);
          });
        }
      });

      let center = new google.maps.LatLng(self.lat, self.lng);
      let offX = (self.el.width() - $(document).width()) / 2;
      let offY = 0;
      map.setCenterWithOffset(center, offX, offY);

      // Add a marker clusterer to manage the markers.
      new MarkerClusterer({
        map,
        markers,
        renderer: GoogleMap.rendeder,
        algorithm: new GridAlgorithm({
          gridSize: 40,
        }),
      });
    },
  },

  init_slider: function () {
    // Add source depending on screen size.
    $(".slide__bg__video").each(function () {
      let video = $(this);
      if ($(window).width() < 1200) {
        video.append(
          "<source type='video/mp4' src='" + video.data("mobile") + "' />"
        );
      } else {
        video.append(
          "<source type='video/mp4' src='" + video.data("pc") + "' />"
        );
      }
    });

    let interval = setInterval(function () {
      if ($(".slide__bg__video.loaded").length) {
        clearInterval(interval);
        $(".slide__bg__video.loaded")
          .closest(".slide__item")
          .addClass("playing");
      }
    }, 100);

    $(".slider").on("init", function () {
      $(".slick-dots").wrap('<div class="hero__dots"></div>');
      // bLazy.load($('.hero__lazy'));
    });

    $(".slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      infinite: false,
      fade: true,
      autoplay: true,
      dots: true,
      arrows: false,
      autoplaySpeed: 5000,
      adaptiveHeight: true,
      customPaging: function (slider, i) {
        return "<span></span>";
      },
    });

    if ($("video").prop("muted", true)) {
      $(".mute-line").addClass("mute-line--mutted");
    }

    $(".toggle-sound").click(function () {
      if ($("video").prop("muted")) {
        $("video").prop("muted", false);
        $(".mute-line").removeClass("mute-line--mutted");
      } else {
        $("video").prop("muted", true);
        $(".mute-line").addClass("mute-line--mutted");
      }
    });
  },
};

export default templateHome;
